import React from "react";
import "./MisionVision.css";

export default function MisionVision() {
  return (
    <div className="mision-vision-section">
      <div className="mision-vision-content">
        <div className="mision-item">
          <h1>Misión</h1>
          <p>
            Ser la empresa líder en equipos y suministros médicos para el área estética en Centroamérica.
            Nos destacaremos por nuestra continua innovación enfocada en ofrecer soluciones vanguardistas
            y eficaces que promuevan la salud y la belleza en armonía. A través de alianzas estratégicas
            y un crecimiento sostenible, buscamos ofrecer las mejores opciones para brindar soluciones reales
            a las necesidades de nuestros clientes, manteniendo una cultura empresarial basada en la colaboración
            y el espíritu emprendedor. Con pasión y dedicación, nos esforzamos por ser referentes positivos en
            nuestro mercado.
          </p>
        </div>

        <div className="vision-item">
          <h1>Visión</h1>
          <p>
            Ser la empresa líder en equipos y suministros médicos para el área estética en Centroamérica.
            Nos destacaremos por nuestra continua innovación y enfoque en ofrecer soluciones vanguardistas
            y eficaces que promuevan la salud y la belleza en armonía. A través de alianzas estratégicas
            y un crecimiento sostenible, buscamos ofrecer las mejores opciones para brindar soluciones reales
            a las necesidades de nuestros clientes, manteniendo una cultura empresarial basada en la colaboración
            y el espíritu emprendedor. Con pasión y dedicación, nos esforzamos por ser referentes positivos en
            nuestro mercado.
          </p>
        </div>
      </div>
    </div>
  );
}
